module.exports = __webpack_public_path__ + "img/ic_leadership@2x.6e7035ec.png";